import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const EngineIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M4.94 14.14H3.4V7.56H4.94V10.02H6.82V7.56H10.96V5.68H8.5V4.14H15.08V5.68H12.62V7.56H17.18V18.08H10.78L6.82 14.14V11.66H4.94V14.14ZM15.44 16.28V9.16H8.56V13.12L11.72 16.28H15.44ZM18.86 9.56H20.6V16.16H18.86V9.56Z" />
    </SvgIcon>
  );
});
